export class EventCodeModel {
	constructor(readonly value : string) {
	}
}



// WEBPACK FOOTER //
// ./src/app/models/eventcode-model.ts